import request from "@/request/request";

export const doLogin = (data) => {
  return request({
    url:'/api/login/authLogin',
    method:'POST',
    data,
  })
};

// 注册
export const doRegister = (data) => {
  return request({
    url:'/api/login/register',
    method:'POST',
    data,
  })
};

// 获取验证码
export const getVerificationCode = (data) => {
  return request({
    url:'/api/msg/sendMsg',
    method:'POST',
    data,
  })
};

// 验证验证码
export const checkMsgCode = (data) => {
  return request({
    url:'/api/msg/checkMsgCode',
    method:'POST',
    data,
  })
};

// 忘记密码验证手机号信息
export const checkMobile = (data) => {
  return request({
    url:'/api/login/checkMobile',
    method:'POST',
    data,
  })
};

// 修改密码
export const updatePasswd = (data) => {
  return request({
    url:'/api/login/updatePasswd',
    method:'POST',
    data,
  })
};